import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-293" data-mp="2urlqfht25jf">
      <div className="max-w-5xl mx-auto" data-id="element-294" data-mp="2tzoz1ch21rk">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-295" data-mp="2x5daeda0zm8">
          <div data-id="element-296" data-mp="3u2x1373l005v">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-5 text-blue-950" data-id="element-297" data-mp="3g9xpvhau0s44">
              See the Skill Before You Teach It
            </h2>
            <p className="text-xl font-semibold text-blue-950 mb-1" data-id="element-298" data-mp="3l90ks8x3lhyd">Driving is practical.</p>
            <p className="text-xl font-semibold text-orange-600 mb-5" data-id="element-299" data-mp="36c1fwstms37l">
              Your teaching material should be practical too.
            </p>
            <p className="text-slate-800 leading-relaxed" data-id="element-300" data-mp="erbw8ip64ztr">
              Driving Instructor Ready uses visual resources throughout the complete 6-in-1 system
              to make complex skills easier for the instructor to explain and easier for the student
              to understand.
            </p>
          </div>

          <div className="bg-stone-50 border border-stone-200 rounded-2xl p-6" data-id="element-301" data-mp="jqeyjvdrkry1">
            <p className="text-sm font-bold text-blue-700 uppercase tracking-wider mb-4" data-id="element-302" data-mp="3s5yr0s6m26c1">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-303" data-mp="3n8ykyh9rh3kx">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-800" data-id="element-304" data-mp="4updbzgekiud">
                  <CheckCircle2 size={16} className="text-green-600 shrink-0 mt-0.5" data-id="element-305" data-mp="14p2z4m338d" />
                  <span data-id="element-306" data-mp="38h6fqy3ol5wx">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <p className="text-center text-2xl md:text-4xl font-serif font-extrabold text-blue-950 mt-14" data-id="element-307" data-mp="34etccgcepk3b">
          <span className="text-orange-600" data-id="element-308" data-mp="17e6yzjcg283y">100% VISUAL.</span> PRACTICAL. READY TO TEACH.
        </p>
      </div>
    </section>;
}